// THE list of deployed games, in landing-page order — the only place a game is
// registered for the web deploy. Read by the landing (cards, 404, JSON-LD),
// the generated rules-page footers, scripts/build-site.mjs (sitemap), the site
// worker's SPA fallback, and CI's page-layout check. `path` is the deployed
// subpath; `app` is the workspace directory under apps/. Names match the
// landing dictionaries' `games.<key>.name`.
//
// Importable on its own as `@bn-games/vite-seo/games` — plain data + string
// helpers, safe for browser and Worker bundles.
export const SEO_GAMES = [
  { key: 'chess', app: 'chess', path: '/chess/', name: { en: 'Chess', ru: 'Шахматы' } },
  { key: 'mahjong', app: 'mahjong', path: '/mahjong/', name: { en: 'Mahjong', ru: 'Маджонг' } },
  { key: 'sudoku', app: 'sudoku', path: '/sudoku/', name: { en: 'Sudoku', ru: 'Судоку' } },
  { key: 'domino', app: 'domino', path: '/domino/', name: { en: 'Dominoes', ru: 'Домино' } },
  { key: 'checkers', app: 'checkers', path: '/checkers/', name: { en: 'Checkers', ru: 'Шашки' } },
  {
    key: 'backgammon',
    app: 'backgammon',
    path: '/long-backgammon/',
    name: { en: 'Long Backgammon', ru: 'Длинные нарды' },
  },
];

export const SEO_LOCALES = ['en', 'ru'];

export const SITE_NAME = 'BN-games';

/** Shared chrome copy for the generated static pages. */
export const LABELS = {
  en: {
    home: 'All games',
    rules: 'Rules',
    moreGames: 'More games',
    language: 'Language',
    breadcrumb: 'Breadcrumb',
    privacy: 'Privacy',
    terms: 'Terms',
  },
  ru: {
    home: 'Все игры',
    rules: 'Правила',
    moreGames: 'Другие игры',
    language: 'Язык',
    breadcrumb: 'Навигация',
    privacy: 'Конфиденциальность',
    terms: 'Условия',
  },
};

export const OG_LOCALE = { en: 'en_US', ru: 'ru_RU' };

/** Landing root per locale. */
export function homePath(locale) {
  return locale === 'ru' ? '/ru/' : '/';
}

/** A game's page for a locale: `/checkers/` or `/checkers/ru/`. */
export function gamePath(path, locale) {
  return locale === 'ru' ? `${path}ru/` : path;
}

/** A game's rules page for a locale: `/checkers/rules/` or `/checkers/ru/rules/`. */
export function rulesPath(path, locale) {
  return `${gamePath(path, locale)}rules/`;
}
